import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogContentText, DialogActions, DialogTitle, Button } from '@material-ui/core';
import moment from 'moment-timezone';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    minWidth: '500px',
    maxHeight: '80vh'
  }
}));

interface ViewUserDialog {
  dialogOpen?: true | false;
  handleDialog?: any;
  userData: any;
}

const ViewUserDialog = (props: ViewUserDialog) => {
  const [open, setOpen] = React.useState<any>(false);
  const classes = useStyles();

  useEffect(() => {
    setOpen(props.dialogOpen);
  }, [props.dialogOpen]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={props.handleDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.dialogPaper }}
        data-testid="View-User-Dialog"
      >
        <DialogTitle id="alert-dialog-title" data-testid="View-User-Dialog-title">
          {'User Information'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" data-testid="View-User-Dialog-description">
            <div data-testid="View-User-Dialog-userName">
              <span>User Name:</span> <span>{props?.userData?.userName}</span>
            </div>
            <div data-testid="View-User-Dialog-firstName">
              <span>First Name:</span> <span>{props?.userData?.firstName}</span>
            </div>
            <div data-testid="View-User-Dialog-lastName">
              <span>Last Name:</span> <span>{props?.userData?.lastName}</span>
            </div>
            <div data-testid="View-User-Dialog-status">
              <span>Status:</span> <span>{props?.userData?.status}</span>
            </div>
            <div data-testid="View-User-Dialog-UCD">
              <span>User Creation Date:</span>{' '}
              <span>{moment(props?.userData?.creationDate).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
            <div data-testid="View-User-Dialog-LMD">
              <span>Last Modified Date:</span>{' '}
              <span>{moment(props?.userData?.lmd).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
            <div data-testid="View-User-Dialog-LLD">
              <span>Last Login Date:</span>{' '}
              <span>{moment(props?.userData?.lastLoginDate).format('MM/DD/YYYY hh:mm:ss A')}</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button onClick={props.handleDialog} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewUserDialog;
